module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "button is-primary is-pulled-right",
    attrs: {
      "to": {
        name: 'tag-create'
      }
    }
  }, [_vm._v("\n        Add tag\n    ")]), _vm._v(" "), _c('data-table', {
    attrs: {
      "data-set": _vm.tags,
      "columns": [{
          name: 'Name',
          type: 'text',
          prop: 'name'
        },
        {
          name: 'Updated',
          type: 'date',
          prop: 'updated_at',
          filter: ['moment', ['from', 'now']]
        },
        {
          name: 'Created',
          type: 'date',
          prop: 'created_at',
          filter: ['moment', ['from', 'now']]
        } ]
    },
    scopedSlots: _vm._u([{
      key: "column_Name",
      fn: function(props) {
        return [_c('router-link', {
          attrs: {
            "to": {
              name: 'tag',
              params: {
                id: props.row.id
              }
            }
          }
        }, [_vm._v("\n                " + _vm._s(props.row.name) + "\n            ")])]
      }
    }, {
      key: "controls",
      fn: function(props) {
        return [_c('td', [_c('div', {
          staticClass: "has-text-right"
        }, [_c('a', {
          staticClass: "delete",
          on: {
            "click": function($event) {
              return _vm.deleteTag(props.row)
            }
          }
        })])])]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d56ffe0a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/src/views/catalog/tags/TagList.vue
// module id = 581
// module chunks = 0